export type ServerEnvironment = 'ssr';
type DesignerEnvironment = 'designer';
type EditorEnvironment = 'editor';

export type BrowserEnvironment = DesignerEnvironment | EditorEnvironment;

export type Environment =
  | BrowserEnvironment
  | ServerEnvironment
  | 'export'
  | 'llm';

export const WebflowEnvironments = Object.freeze({
  DESIGNER: 'designer' as DesignerEnvironment,
  EDITOR: 'editor' as EditorEnvironment,
  SSR: 'ssr' as ServerEnvironment,
  EXPORT: 'export' as const,
  LLM: 'llm' as const,
});
